import mutate, { addToCache } from '@/utils/mutateWrapper'
import {
  GET_VIEWER_QUERY,
  UPDATE_VIEWER_MUTAION,
  SETUP_PROFILE_MUTAION,
  DELETE_VIEWER_MUTAION,
  REQUEST_PHONE_VERIFICATION_MUTAION,
  CHECK_VERIFICATION_CODE_MUTAION,
  APPLY_PROMO_CODE_MUTAION
} from '../gql/user.gql'

export const setupProfile = data => mutate(SETUP_PROFILE_MUTAION, { data })

export const updateViewer = data => {
  const update = addToCache(GET_VIEWER_QUERY, 'getViewer')
  return mutate(UPDATE_VIEWER_MUTAION, { data }, { update })
}

export const deleteViewer = data => mutate(DELETE_VIEWER_MUTAION, { data })

export const sendVerificationCode = phone =>
  mutate(REQUEST_PHONE_VERIFICATION_MUTAION, { phone })

export const verifyCode = ({ phone, code, target }) =>
  mutate(CHECK_VERIFICATION_CODE_MUTAION, { phone, code, target })

export const applyPromoCode = code => mutate(APPLY_PROMO_CODE_MUTAION, { code })
